<template>
  <multi-dropdown-list
    :componentId="componentId"
    :data-field="dataField"
    :showFilter="false"
    :URLParams="true"
    :react="{
      and: reactTo
    }"
    :title="$t(title)"
  >
    <template slot="renderLabel" slot-scope="labels">
      {{ $t('Selección') }} ({{ Object.keys(labels).length }})
    </template>
    <template slot="renderItem" slot-scope="{ label, count }">
      <div>{{ $t(label) }}</div>
      <span :style="{ marginLeft: 5, color: 'dodgerblue' }">
        {{ count }}
      </span>
    </template>
  </multi-dropdown-list>
</template>

<script>
export default {
  name: 'FilterSelector',
  props: {
    componentId: {
      type: String,
      required: true
    },
    dataField: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    sensors: {
      type: Array,
      required: true
    }
  },
  data() {
    return {}
  },
  computed: {
    reactTo() {
      let self = this
      return self.sensors.filter(sensor => sensor != self.componentId)
    }
  },
  methods: {}
}
</script>
